// extracted by mini-css-extract-plugin
export var legendIndicator = "_dv-1";
export var legendRight = "_dv-0";